import { NextSeo } from 'next-seo';
import Head from 'next/head';

//screens
import { Flatbed } from '/screens/';

//data-helpers
import { JsonLd } from '@/datafiles/micro-data/';
import { FAQ } from '@/datafiles/micro-data/faq';

export default function FlatbedMessengerPage() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="Flatbed trucks, Flatbed trucking, flatbed services, flatbed freight, flatbed trucking companies, trucking company, flatbed loads, freight backhauls, flatbed hauling, flatbed freight companies "
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        canonical="https://loadsmart.com/shipper/flatbed-messenger/"
        openGraph={{
          url: 'https://loadsmart.com/shipper/flatbed-messenger/',
        }}
        title="Flatbed Freight Services | Flatbed Messenger"
        description="Flatbed Messenger is a network wide capacity solution that seamlessly covers spot and contract freight. We match shippers to carriers at a fraction of the market rate."
      />
      <JsonLd data={FAQ} />
      <Flatbed />
    </>
  );
}
